import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { graphql, useStaticQuery } from 'gatsby';

import { SitemapQuery } from '../../generated/types/gatsby';
import { buildMenuTree } from '../fragments/MenuItem.mappers';
import { languageFallback } from '../utils/localizations';

function extractItemsByLocale<
  TInput extends Array<{ langcode: string }>,
  TKey extends TInput[number]['langcode'],
>(input: TInput, langcode: TKey): TInput[number] | undefined {
  return input.filter((item) => item.langcode === langcode).pop();
}

export const useMenus = (pageContext: SilverbackPageContext) => {
  const defaultLocale = 'de';

  const result = useStaticQuery<SitemapQuery>(graphql`
    query Sitemap {
      main: drupalMenuMain {
        translations {
          items {
            ...MenuItem
          }
          langcode
        }
      }
      meta: drupalMenuMeta {
        translations {
          items {
            ...MenuItem
          }
          langcode
        }
      }
      footer: drupalMenuFooter {
        translations {
          items {
            ...MenuItem
          }
          langcode
        }
      }
      donation: drupalMenuDonation {
        translations {
          items {
            ...MenuItem
          }
          langcode
        }
      }
      quick: drupalMenuQuick {
        translations {
          items {
            ...MenuItem
          }
          langcode
        }
      }
      social: drupalMenuSocial {
        translations {
          items {
            ...MenuItem
          }
          langcode
        }
      }
    }
  `);

  const actualLocale = languageFallback(pageContext.locale || defaultLocale);

  return {
    menus: {
      main: {
        id: 'main',
        label: 'Hauptmenü',
        items: buildMenuTree(
          extractItemsByLocale(result.main?.translations || [], actualLocale)
            ?.items || [],
        ),
      },
      meta: {
        id: 'meta',
        label: 'Metanavigation',
        items: buildMenuTree(
          extractItemsByLocale(result.meta?.translations || [], actualLocale)
            ?.items || [],
        ),
      },
      footer: {
        id: 'footer',
        label: 'Footernavigation',
        items: buildMenuTree(
          extractItemsByLocale(result.footer?.translations || [], actualLocale)
            ?.items || [],
        ),
      },
      donation: {
        id: 'donation',
        label: 'Donation',
        items: buildMenuTree(
          extractItemsByLocale(
            result.donation?.translations || [],
            actualLocale,
          )?.items || [],
        ),
      },
      quick: {
        id: 'quick',
        label: 'Quick links',
        items: buildMenuTree(
          extractItemsByLocale(result.quick?.translations || [], actualLocale)
            ?.items || [],
        ),
      },
      social: {
        id: 'social',
        label: 'Social links',
        items: buildMenuTree(
          extractItemsByLocale(result.social?.translations || [], actualLocale)
            ?.items || [],
        ),
      },
    },
  };
};
